// @vendors
import { Button, Form, Input } from "antd";
import { useState } from "react";
// @styles 
import './styles.scss'
import { Fade } from 'react-reveal'


export default function ContinueProcess({ data, handleChange, loadBtn }) {
    const [value, setValue] = useState("");
    const regex = '^[A-Z0-9]*$';
    const info = data.primary
    return (
        <div className='process__container' id={info.idcontent}>
            <Fade left cascade delay={0.3}>
                <div className="container-xl">
                    <div className='process__container-content'>
                        {info.sectiontitle && (
                            <>
                                <div className='homepage__container-title left-title'>
                                    <p>{info.sectiontitle ? info.sectiontitle : ""}</p>
                                </div>
                            </>
                        )}
                        <div className="process__container-content__actions">
                            <div className="process__container-content__actions-input">
                                <Form.Item label={info.fieldname ? info.fieldname : ""}>
                                    <Input disabled={loadBtn} maxLength={13} placeholder='0000000000000' onChange={(e) => setValue(e.target.value)} />
                                </Form.Item>
                            </div>
                            {info.buttonname && (
                                <Button
                                    data-testId="COTIZA AHORA"
                                    onClick={() => handleChange(value)}
                                    loading={loadBtn}
                                    className='ant-btn-solid c-3 ant-btn-size-xs'
                                    disabled={!value || !(new RegExp(regex).test(value))}
                                >
                                    <div>{info.buttonname}</div>
                                </Button>
                            )}
                        </div>
                    </div>
                </div>
            </Fade>
        </div>
    )
}